import { FunctionComponent, PropsWithChildren } from "react";
import { IRadioProps } from "./interfaces/IRadioProps";
import "./styles/radio.css";

export const Radio: FunctionComponent<PropsWithChildren<IRadioProps>> = (props) => {
    return (
        <label id={props.id} className="cui-radio__label">
            <input
                className="cui-radio__input"
                type="radio"
                name={props.name}
                value={props.value}
                data-hook="radio-input"
                checked={props.isChecked}
                disabled={props.isDisabled}
                required={props.isRequired}
                onChange={(event) => props.onChange(event.target.value)}
            />
            {props.children}
        </label>
    );
};
